import {type NodePojo} from './NodePojo';

export const isNodePojo = (obj: unknown): obj is NodePojo => {
  if (!obj || typeof obj !== 'object') return false;
  return 'id' in obj && typeof obj.id === 'string';
};
